export const voucherTypeOptions = [
	{ value: 'receipt', label: 'Phiếu thu' },
	{ value: 'expense', label: 'Phiếu chi' },
	{ value: 'salary',  label: 'Phiếu lương' },
];

export const voucherTypeLabels = {
	receipt : 'Phiếu thu',
	expense : 'Phiếu chi',
	salary  : 'Phiếu lương',
};

export const voucherTypeColors = {
	receipt : 'green',
	expense : 'orange',
	salary  : 'blue',
};

export const dayOfMonthOptions = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: `Ngày ${i + 1}` }));

export const activeOptions = [
	{ value: 1, label: 'Đang chạy' },
	{ value: 0, label: 'Tạm dừng' },
];

export const costTypeOptions = [
	{ value: 'fixed', label: 'Cố định' },
	{ value: 'incidental', label: 'Phát sinh' },
	{ value: 'service', label: 'Dịch vụ' },
	{ value: 'diplomatic', label: 'Ngoại giao' },
	{ value: 'bonus', label: 'Thưởng' },
	{ value: 'other', label: 'Khác' },
];

export const paymentOptions = [
	{ value: 'cod', label: 'Tiền mặt' },
	{ value: 'bank', label: 'Chuyển khoản' },
	{ value: 'momo', label: 'Ví Momo' },
	{ value: 'swipe', label: 'Pos' },
];
